import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e211733"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "คำสั่ง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ประกาศใช้เมื่อ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จำนวน ร.นรม./รมต.นร."),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("เพิ่มหนังสือคำสั่ง ")
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinets, (cabinet, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass([{'table-active': cabinet.status === 0}, "row-hover"]),
                    onClick: ($event: any) => (_ctx.selectedClick(cabinet.id))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, [
                      _hoisted_6,
                      _createTextVNode(_toDisplayString(cabinet.name), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(cabinet.startDate)), 1),
                    _createElementVNode("td", null, _toDisplayString(cabinet.ministerCount), 1),
                    _withDirectives(_createElementVNode("td", null, null, 512), [
                      [_directive_dompurify_html, _ctx.statusHtml(cabinet.status)]
                    ])
                  ], 10, _hoisted_5))
                }), 128))
              ])
            ], 512)
          ]))
    ])
  ], 64))
}